import axios from "axios"
import Cookies from 'js-cookie'
const token = Cookies.get('authToken')




const eventIndexHeaders = {

    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  
  }
  const getEventIndexes = async (video) => {
    const response = await axios.get(`https://${window.process.env.API_HOST_GLOBAL}/video-api/video/${video}/chapters`,{headers:eventIndexHeaders})
     return response
  };
  const postEventIndexes = async (videoId, chapters) => {
    try {
      const response = await axios.post(
        `https://${window.process.env.API_HOST_GLOBAL}/video-api/video/${videoId}/chapters`,
        chapters,
        {headers:eventIndexHeaders}
      );
      return response.data;
    } catch (error) {
      console.error('Failed to post chapters:', error);
      throw error;
    }
  };
  const deleteEventIndexes = async (videoId, ids) => {
    try {
      const response = await axios.delete(
        `https://${window.process.env.API_HOST_GLOBAL}/video-api/video/${videoId}/chapters`,
        {
            headers:eventIndexHeaders,
          data: {
            delete_all: false,
            ids: ids,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Failed to delete chapters:', error);
      throw error;
    }
  };
  const exportEventIndexes = async (eventId) => {
    const response = await axios.get(`https://${window.process.env.API_HOST_GLOBAL}/video-api/video/${eventId}/chapters/export`,{headers:eventIndexHeaders})
     return response

  }
  
  export {
    deleteEventIndexes,
    getEventIndexes,
    postEventIndexes,
    exportEventIndexes
  }